// extracted by mini-css-extract-plugin
module.exports = {"input_prefix":"input_input_prefix__3YOjI"};